import React, { Component } from 'react'
import { connect } from 'react-redux'
import TouchKeyboardButton from './TouchKeyboardButton'
import { toggleKeyboard, executeOKFunction, updateKeyboardInput } from '../actions/layoutActions'
import $ from 'jquery'
import * as keyboardFunctions from '../functions/KeyboardFunctions'
import * as keyboardLayout from '../constants/Keyboard'
import * as settings from '../constants/Settings';
import PropTypes from 'prop-types'

class TouchKeyboard extends Component {
  constructor(props) {
    super(props);
    this.handlekeypress = this.handlekeypress.bind(this);
    this.state = {
      shift: false,
      showNumbers: false
    };
    this.hideKeyboard = this.hideKeyboard.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.updateInput = this.updateInput.bind(this);
  }

  handleKeyDown(e) {
    const charString = keyboardFunctions.handleKeyboardEvent(e);
    this.handlekeypress(charString, e);
  }

  hideKeyboard() {
    const {
      inputid,
      toggleKeyboard
    } = this.props;

    this.state = {
      shift: false,
      showNumbers: false
    };
    if (inputid) $(inputid).blur();

    // Remove event listener for physical keyboard when the keyboard hides
    document.removeEventListener('keydown', this.handleKeyDown);

    toggleKeyboard(false);
  }

  handlekeypress(text, e) {
    const {
      executeOKFunction,
      input,
      initinput
    } = this.props;

    let inputvalue = input || '';
    const inputfield = $('#keyboardinput');
    const originalPos = inputfield[0].selectionStart;

    const insertText = t => {
      inputvalue = inputvalue.substr(0, originalPos) + t + inputvalue.substr(originalPos);
      setTimeout(() => {
      inputfield[0].setSelectionRange(originalPos + t.length, originalPos + t.length);
      }, 0);
      this.updateInput(inputvalue);
    }

    if (!(e && (e.altKey || e.ctrlKey))) {
      switch (text.toUpperCase()) {
        case 'SHIFT':
          this.setState(state => ({ shift: !state.shift }));
          break;
        case '&123':
          this.setState(state => ({ showNumbers: !state.showNumbers }));
          break;
        case 'ENTER':
          this.hideKeyboard();
          break;
        case 'OK':
          this.hideKeyboard();
          executeOKFunction();
          break;
        case 'KEYBOARD':
          this.hideKeyboard();
          break;
        case 'ANNULEER':
          this.updateInput(initinput);
          this.hideKeyboard();
          break;
        case 'KEYBOARDLEFT':
        case 'KEYBOARDRIGHT':
          inputfield[0].setSelectionRange(originalPos, originalPos);
          break;
        case 'LEFT':
          inputfield[0].setSelectionRange(originalPos - 1, originalPos - 1);
          break;
        case 'RIGHT':
          inputfield[0].setSelectionRange(originalPos + 1, originalPos + 1);
          break;
        case 'BACKSPACE':
          if (inputvalue.length > 1) {
            if (originalPos > 0) {
              inputvalue = inputvalue.slice(0, originalPos - 1) + inputvalue.slice(originalPos);
              setTimeout(() => {
                inputfield[0].setSelectionRange(originalPos - 1, originalPos - 1);
              }, 0);
            }
          } else {
            inputvalue = ''
          }
          this.updateInput(inputvalue);
          break;
        case 'DELETE':
          if (inputvalue.length > 1) {
            inputvalue = inputvalue.slice(0, originalPos) + inputvalue.slice(originalPos + 1);
            setTimeout(() => {
              inputfield[0].setSelectionRange(originalPos, originalPos);
            }, 0);
          } else {
            inputvalue = ''
          }
          this.updateInput(inputvalue);
          break;
        default:
          insertText(text);
          break;
      }
    }
    else if (e && e.ctrlKey) {
      if (e.key === 'v') {
        navigator.clipboard.readText().then(result => {
          insertText(result);
        })
      }
    }
    inputfield.focus();
  }

  updateInput(inputvalue) {
    const {
      inputid,
      updateKeyboardInput
    } = this.props;

    this.setState({ shift: false });
    updateKeyboardInput(inputvalue);

    if (inputid) $(inputid).val(inputvalue);
  }

  render() {
    const {
      inputid,
      message,
      showkeyboard,
      input
    } = this.props;

    let style = {
      display: 'none'
    }
    if (showkeyboard) {
      style = {
        display: 'inline-block'
      }
      // Add event listener for physical keyboard
      document.addEventListener('keydown', this.handleKeyDown);
    }

    // Decide which keylayout to use
    let keys = [];
    if (!this.state.showNumbers && settings.KEYBOARD_TYPE === 'QWERTY') {
      keys = keyboardLayout.QWERTY;
    } else if (!this.state.showNumbers && settings.KEYBOARD_TYPE === 'AZERTY') {
      keys = keyboardLayout.AZERTY;
    } else {
      keys = keyboardLayout.SPECIAL_CHARACTERS;
    }

    const inputtype = inputid ? $(inputid).attr('type') : 'text';

    return (
      <div className="touchkeyboardwrapper" style={style}>
        <div className="hideclickarea" onClick={this.hideKeyboard}>
        </div>
        <div className="touchkeyboard" style={style}>
          <div className="keyboardrowinputtitle">
            {message}
          </div>
          <div className="keyboardrowinput">
            <input id="keyboardinput" type={inputtype} value={input} readOnly="readonly" />
          </div>
          <div className="keyboardkeys">
            {
              keys.map(btn =>
                <TouchKeyboardButton
                  key={btn.key}
                  text={btn.value}
                  shift={btn.shift}
                  handlekeypress={this.handlekeypress}
                  shiftactive={this.state.shift}
                  width={btn.width}
                  height={btn.height}
                  x={btn.x}
                  y={btn.y}
                  color={btn.color}
                  icon={btn.icon}
                />
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

TouchKeyboard.propTypes = {
  showkeyboard: PropTypes.bool,
  inputid: PropTypes.string,
  toggleKeyboard: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    showkeyboard: state.layoutState.keyboard.show,
    inputid: state.layoutState.keyboard.inputid,
    input: state.layoutState.keyboard.input,
    initinput: state.layoutState.keyboard.initinput,
    message: state.layoutState.keyboard.message
  }
}

export default connect(mapStateToProps, { toggleKeyboard, executeOKFunction, updateKeyboardInput })(TouchKeyboard)



// WEBPACK FOOTER //
// src/components/TouchKeyboard.jsx